import React, {Component} from "react";
import PropTypes from "prop-types";
import {Col, Collapse} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./SidebarModern.css";
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.jsx";
import logo from "assets/img/logo.png";
import routes from "routes/app.jsx";

let ps;

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.getCollapseStates(routes),
            isWindows: navigator.platform.indexOf("Win") > -1 ? true : false,
            width: window.innerWidth
        };
        this.sidebarWrapper = React.createRef();
    }

    getCollapseStates = routes => {
        let initialState = {};
        routes.map((prop, key) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: this.getCollapseInitialState(prop.views),
                    ...this.getCollapseStates(prop.views),
                    ...initialState
                };
            }
            return null;
        });
        return initialState;
    };

    getCollapseInitialState(routes) {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (window.location.href.indexOf(routes[i].path) !== -1) {
                return true;
            }
        }
        return false;
    }

    createLinks = routes => {

        return routes.map((prop, key) => {
            // Filtrer les routes selon le type d'utilisateur
            if (prop.redirect || prop.name === "Prix") {
                return null;
            }

            // Réserver les liens d'administration aux administrateurs.
            if (prop.name === "Administration" && !this.props.isAdmin) {
                return null;
            }

            // Si la route est cachée et que l'utilisateur n'est pas admin, ne pas l'afficher
            if (prop.hidden && !this.props.isAdmin) {
                return null;
            }

            if (prop.collapse) {
                let st = {};
                st[prop["state"]] = !this.state[prop.state];
                return (
                    <li
                        className={this.getCollapseInitialState(prop.views) ? "active" : ""}
                        key={key}
                        style={{
                            margin: '5px 0',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <a
                            href="#pablo"
                            onClick={e => {
                                e.preventDefault();
                                this.setState(st);
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                margin: '2px 0',
                                transition: 'all 0.3s ease',
                                background: 'transparent',
                                color: '#666',
                                textDecoration: 'none',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'linear-gradient(135deg, rgba(var(--app-primary-rgb), 0.1) 0%, rgba(var(--app-primary-rgb), 0.1) 100%)';
                                e.target.style.transform = 'translateX(5px)';
                                e.target.style.boxShadow = '0 4px 15px rgba(var(--app-primary-rgb), 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <i
                                    className={prop.icon}
                                    style={{
                                        fontSize: '16px',
                                        width: '20px',
                                        textAlign: 'center',
                                        transition: 'all 0.3s ease'
                                    }}
                                />
                                <p style={{
                                    margin: 0,
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {prop.name}
                                </p>
                            </div>
                            <b
                                className={
                                    this.state[prop.state] ? "caret rotate-180" : "caret"
                                }
                                style={{
                                    transition: 'transform 0.3s ease',
                                    fontSize: '12px',
                                    color: '#999'
                                }}
                            />
                        </a>
                        <Collapse in={this.state[prop.state]}>
                            <ul className="nav" style={{
                                paddingLeft: '20px',
                                marginTop: '5px'
                            }}>
                                {this.createLinks(prop.views)}
                            </ul>
                        </Collapse>
                    </li>
                );
            }
            return (
                <li className={this.activeRoute(prop.path)} key={key} style={{
                    margin: '5px 0',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease'
                }}>
                    <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                        onClick={(e) => {
                            if (window.innerWidth < 993) {
                                document.documentElement.classList.remove("nav-open");
                            }
                        }}
                        style={{
                            pointerEvents: 'auto',
                            cursor: 'pointer',
                            zIndex: 10,
                            position: 'relative',
                            display: 'block',
                            textDecoration: 'none',
                            padding: '12px 15px',
                            borderRadius: '8px',
                            margin: '2px 0',
                            transition: 'all 0.3s ease',
                            background: 'transparent',
                            color: '#666'
                        }}
                        onMouseEnter={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.background = 'linear-gradient(135deg, rgba(var(--app-primary-rgb), 0.1) 0%, rgba(var(--app-primary-rgb), 0.1) 100%)';
                                e.target.style.transform = 'translateX(5px)';
                                e.target.style.boxShadow = '0 4px 15px rgba(var(--app-primary-rgb), 0.2)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.background = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = 'none';
                            }
                        }}
                    >
                        {prop.icon ? (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <i
                                    className={prop.icon}
                                    style={{
                                        fontSize: '16px',
                                        width: '20px',
                                        textAlign: 'center',
                                        transition: 'all 0.3s ease'
                                    }}
                                />
                                <p style={{
                                    margin: 0,
                                    fontWeight: '500',
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {prop.name}
                                </p>
                            </div>
                        ) : (
                            <>
                                <span className="sidebar-mini">{prop.mini}</span>
                                <span className="sidebar-normal">{prop.name}</span>
                            </>
                        )}
                    </NavLink>
                </li>
            );
        });
    };

    activeRoute = routeName => {
        return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };

    updateDimensions() {
        this.setState({width: window.innerWidth});
    }

    componentDidUpdate() {
        if (navigator.platform.indexOf("Win") > -1) {
            setTimeout(() => {
                ps.update();
            }, 350);
        }
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(this.sidebarWrapper.current, {
                suppressScrollX: true,
                suppressScrollY: false
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
        }
    }

    render() {
        return (
            <div
                className="sidebar"
                data-color={this.props.color}
                data-image={this.props.image}
            >
                {this.props.hasImage ? (
                    <div
                        className="sidebar-background"
                        style={{backgroundImage: "url(" + this.props.image + ")"}}
                    />
                ) : (
                    ""
                )}
                <div className="logo">
                    <a
                        href="https://www.bossoftwaresolutions.com"
                        className="simple-text logo-mini"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Col md={6} sm={6}>
                            <div className="logo-img">
                            </div>
                        </Col>
                    </a>
                    <a
                        href="https://www.bossoftwaresolutions.com"
                        className="simple-text logo-normal"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        APURMED
                    </a>
                </div>
                <div className="sidebar-wrapper" ref={this.sidebarWrapper}>
                    <ul className="nav" style={{
                        padding: '0 10px'
                    }}>
                        {this.state.width <= 992 ? <AdminNavbarLinks/> : null}
                        {this.createLinks(routes)}
                    </ul>

                    <div style={{
                        position: 'absolute',
                        bottom: '20px',
                        left: '15px',
                        right: '15px'
                    }}>
                        <div style={{
                            textAlign: 'center',
                            marginBottom: '15px',
                            padding: '15px'
                        }}>
                            <img
                                src={logo}
                                alt="Logo"
                                style={{
                                    width: '120px',
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                }}
                            />
                        </div>

                        <div style={{
                            background: 'rgba(255,255,255,0.95)',
                            borderRadius: '10px',
                            padding: '10px',
                            textAlign: 'center',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                            border: '1px solid rgba(255,255,255,0.8)'
                        }}>
                            <p style={{
                                margin: 0,
                                fontSize: '11px',
                                color: '#666',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '5px'
                            }}>
                                <i className="fa fa-copyright"></i>
                                <span>2025</span>
                            </p>
                            <p style={{
                                margin: 0,
                                fontSize: '10px',
                                color: '#888',
                                marginTop: '2px'
                            }}>
                                Tous droits réservés
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Sidebar.propTypes = {
    location: PropTypes.object,
    color: PropTypes.string,
    hasImage: PropTypes.bool,
    image: PropTypes.string,
    isAdmin: PropTypes.bool
};

export default Sidebar;